import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowRegionGroup extends BookShow {
    get dropdActions() {
        const { canEditBooks } = this.props;

        const actions = [];

        if (canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }

        return actions;
    }

    renderBody = () => {
        const { config } = this.props;

        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowRegionGroup {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "region-groups");
